import type { SubscriptionTypes } from "@component/Widget/NewsletterSubscribe/NewsletterSubscribe";
import type { ReactNode } from "react";
import React from "react";
import type { SmeLoanLeadFormWithCurrencyInputsCalcRequest } from "../LeadFormWithCurrencyInputs/SmeLoanLeadFormWithCurrencyInputs";
import { SmeLoanLeadFormWithCurrencyInputs } from "../LeadFormWithCurrencyInputs/SmeLoanLeadFormWithCurrencyInputs";
import * as Step from "./Steps";

/**
 * @Shortcode
 *
 * @title "Vállalati Rapid hitel leadform"
 * @shortcode "sme_loan_rapid_lead"
 * @slug "vallalati-rapid-hitel"
 * @type "leadform"
 */
export class SmeLoanRapidLeadForm extends SmeLoanLeadFormWithCurrencyInputs {
	// EventParams
	protected readonly productTypes: string = "SME_LOAN";
	protected readonly componentType: string = "leadform";
	protected readonly subscriptionTypes: SubscriptionTypes[] = ["CORPORATE_NEWSLETTER"];

	public static defaultProps = {
		title: "Kérj segítséget szakértőnktől!",
		colorScheme: "light",
		bottomLogo: false,
	};

	protected renderSteps(): ReactNode {
		const { title } = this.props;
		const {
			values: { email },
			submitState,
		} = this.state;

		return (
			<>
				<Step.LeadForm
					stepName="lead-form"
					defaultTarget="success-page"
					title={title}
					button="Érdekel a hitel"
					submitState={submitState}
				/>
				<Step.SuccessPage
					stepName="success-page"
					userEmail={email}
					subscriptionTypes={this.subscriptionTypes}
				/>
			</>
		);
	}

	protected getCalculatorRequest(): SmeLoanLeadFormWithCurrencyInputsCalcRequest {
		return {
			...super.getCalculatorRequest(),
			equity: 0,
			operatingProfit: 0,
		};
	}

	protected getClassName(): string {
		return `${super.getClassName()} sme-loan-rapid`;
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SmeLoanRapidLeadForm`;
	}
}

export default SmeLoanRapidLeadForm;
